import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Loader } from "@/components/shared/loader";

interface RejectNoteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  isLoading?: boolean;
  onConfirm: (note: string) => void;
}

export function RejectNoteDialog({
  open,
  onOpenChange,
  title,
  isLoading,
  onConfirm,
}: RejectNoteDialogProps) {
  const [note, setNote] = useState("");

  const handleConfirm = () => {
    onConfirm(note.trim());
    setNote("");
  };

  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) setNote("");
        onOpenChange(o);
      }}
    >
      <DialogContent className="max-w-md" dir="rtl">
        <DialogHeader>
          <DialogTitle className="text-right">تأكيد الرفض</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground text-right">{title}</p>
        <Textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="ملاحظة الرفض (اختياري)"
          rows={3}
          dir="rtl"
        />
        <DialogFooter className="gap-2 sm:justify-start">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            إلغاء
          </Button>
          <Button variant="destructive" disabled={isLoading} onClick={handleConfirm}>
            {isLoading ? <Loader size="sm" /> : "رفض"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
